import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/", end: true },
  { label: "主角档案", to: "/renwu" },
  { label: "事件溯源", to: "/zixun" },
  { label: "立场与声明", to: "/about" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur">
      {/* top ticker strip */}
      <div className="hidden md:block border-b border-background-200 bg-background-100">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-1.5 md:px-6">
          <p className="flex items-center gap-2 text-xs text-foreground-600">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary-500" />
            持续梳理反差人物身份与来源线索，谨慎看待未经核实的网络说法。
          </p>
          <p className="text-xs text-foreground-500">公开信息整理 · 仅供参考</p>
        </div>
      </div>

      {/* main bar */}
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
        <Link to="/" className="group flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-eye-2-line text-lg" />
          </span>
          <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
            反差<em className="not-italic text-primary-600">追踪</em>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `rounded-md px-3.5 py-2 text-sm whitespace-nowrap transition-colors ${
                  isActive
                    ? "bg-primary-600 text-background-50"
                    : "text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/zixun"
            className="hidden items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3.5 py-2 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700 lg:flex"
          >
            <i className="ri-search-line" />
            <span>搜索线索</span>
          </Link>
          <Link
            to="/zixun"
            className="hidden whitespace-nowrap rounded-md bg-accent-500 px-3.5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 md:inline-flex"
          >
            最新消息
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-200 md:hidden"
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </div>

      {/* mobile menu */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm ${
                    isActive
                      ? "bg-primary-600 text-background-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}